import React from 'react';

var FooterUserInfo = function (_a) {
    var isShowBalanceWin = _a.isShowBalanceWin, children = _a.children;
    return React.createElement("div", { className: "pgc-footer-user-info ".concat(isShowBalanceWin ? 'balance-win' : '') }, children);
};

export { FooterUserInfo };
